import { createContext, useContext } from 'react';

interface TenantContextType {
  selectedTenantId: string;
  setSelectedTenantId: (id: string) => Promise<void>;
  isReady: boolean;
}

export const TenantContext = createContext<TenantContextType | undefined>(undefined);

export function useTenant() {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}
